module.exports =[
  {
    conditions: {
      status: 0, // draft
    },
    style: 'warning',
    icon: 'fa fa-inbox',
    label: 'Orders.statusReceived',
    name: 'received',
    title: 'Orders.statusReceived',
    description: 'Orders.statusReceivedDescr',
    optional: false,
    terminate: false,
  },
  {
    // order processing
    conditions: {
      status: 1, // booked
      orderstatus: [
        'order_accepted',
        'customer_approval_required',
        'customer_approved',
        'in_design',
        'design_approved',
        'design_rework_required',
      ],
    },
    style: 'warning',
    icon: 'fa fa-thumbs-up',
    label: 'Orders.statusInProgress',
    name: 'inprogress',
    title: 'Orders.statusInProgress',
    description: 'Orders.statusInProgressDescr',
    optional: false,
    terminate: false,
  },
  {
    // order cancelled
    conditions: {
      status: 3, // Cancelled
    },
    style: 'warning',
    icon: 'fa fa-times',
    label: 'Orders.statusCancelled',
    name: 'cancelled',
    title: 'Orders.statusCancelled',
    description: 'Orders.statusCancelledDescr',
    optional: true,
    terminate: true,
  },
  {
    // production started
    conditions: {
      status: 1, // booked
      orderstatus: ['in_production', 'production_rework_required', 'qc']
    },
    style: 'info',
    icon: 'fa fa-cogs',
    label: 'Orders.statusInProduction',
    name: 'inproduction',
    title: 'Orders.statusInProduction',
    description: 'Orders.statusInProductionDescr',
    optional: false,
    terminate: false,
  },
  {
    conditions: {
      status: [1, 4, 12], // Complete
      orderstatus: ['ready', 'shipped']
    },
    style: 'warning',
    icon: 'fa fa-truck',
    label: 'Orders.statusDelivered',
    name: 'delivered',
    title: 'Orders.statusDelivered',
    description: 'Orders.statusDeliveredDescr',
    optional: false,
    terminate: false,
  }
];
